import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import Form from "react-bootstrap/Form";
import { useDispatch } from "react-redux";
import { getMedallions } from "../redux/actions/medallion";
import { MEDALLION_TYPES } from "../constants/medallionTypes";
import PaginationComponent from "../components/Pagination";

export default function ViewMemories() {
  const [scrolled, setScrolled] = useState(false);
  const [medallionType, setMedallionType] = useState(MEDALLION_TYPES.HUMAN);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [medallions, setMedallions] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const handlePageChange = (page) => {
    setPage(page + 1);
    navigate(`/view-memories?page=${page + 1}`);
  };

  const handleTypeToggle = () => {
    setMedallionType(medallionType === MEDALLION_TYPES.HUMAN ? MEDALLION_TYPES.PET : MEDALLION_TYPES.HUMAN);
    setPage(1);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(0);
    fetchMedallions();
  };

  const clearSearch = () => {
    setSearch("");
    setPage(0);
    fetchMedallions('noSearch')
  };

  const downloadQRCode = (qrCodeUrl) => {
    window.open(qrCodeUrl, '_blank');
  };

  const fetchMedallions = async (noSearch) => {
    try {
      const payload = {
        type: medallionType,
        page: page > 0 ? page - 1 : 0,
        limit
      };
      if (search.trim() && !noSearch) {
        payload.search = search;
      }
      const response = await dispatch(getMedallions(payload)).unwrap();
      setMedallions(response.data || []);
      setTotalPages(Math.ceil((response.data?.total || 0) / limit));
      setTotal(response.data?.total);
    } catch (error) {
      console.error("Error fetching medallions:", error);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    fetchMedallions();
  }, [medallionType, page]);
  return (
    <Layout>
      <section className="profile-banner-sec">
        <Container>
          <div className="recommended-gifts-bnnr mt-5">
            <h1>Find a Memory</h1>
            <p>Search a memory of a loved one</p>
            <form onSubmit={handleSearch}>
              <div className="recommended-gifts-input" style={{ position: 'relative' }}>
                <input
                  type="text"
                  placeholder="Enter name"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    if (e.target.value === "") {
                      fetchMedallions('noSearch')
                    }
                  }}
                />
                {search && (
                  <button
                    type="button"
                    onClick={clearSearch}
                    style={{
                      position: 'absolute',
                      right: '80px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      fontSize: '18px',
                      cursor: 'pointer',
                      color: '#999'
                    }}
                  >
                    ×
                  </button>
                )}
                <button type="submit">submit</button>
              </div>
            </form>
          </div>
        </Container>
      </section>
      <section className="find-a-memory p-80">
        <Container>
          <div className="find-a-memory-date">
            <div className="find-a-memory-title">
              <p>Person</p>
              <Form>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  checked={medallionType === MEDALLION_TYPES.PET}
                  onChange={handleTypeToggle}
                />
              </Form>
              <p>Pet</p>
            </div>
            <div className="find-a-memory-cards">
              {medallions?.medallion?.length ? medallions?.medallion?.map((medallion, index) => (
                <div key={index} className="find-a-memory-item mb-4">
                  <div className="">
                    <img src={medallion?.profile_image || medallion?.qr_code_url} />
                    <div className="">
                      <h3>{medallion.name}</h3>
                      <p>{medallion.description || 'No description available'}</p>
                    </div>
                  </div>
                  <div>
                    <button onClick={() => navigate(`/profile/${medallion._id}`)} >View Memory</button>
                    <button onClick={() => navigate(`/edit-profile/${medallion._id}`)} >Edit</button>
                    <button
                      onClick={() => downloadQRCode(medallion.qr_code_url)}
                      className=""
                    >
                      Share
                    </button>
                  </div>
                </div>
              )) : (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                  <h3>No medallions found</h3>
                  <p>Try adjusting your search or filter criteria</p>
                </div>
              )}

              {/* {(medallions?.medallion?.length > 0) && (
                <div className="find-a-memory-action">
                  <button
                    onClick={() => setPage(Math.max(0, page - 1))}
                    disabled={page === 0}
                  >
                    Previous
                  </button>
                  <span>Page {page + 1} of {totalPages}</span>
                  <button
                    onClick={() => setPage(page + 1)}
                    disabled={page + 1 >= totalPages}
                  >
                    Next
                  </button>
                </div>
              )} */}
              {total > 0 ?
                <PaginationComponent
                  currentPage={page - 1}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  totalEntries={total}
                  entriesPerPage={limit}
                />
                :
                null
              }
            </div>
          </div>
        </Container>
      </section>
    </Layout>
  );
}